<template>
  <div class="equityCenterBox" v-if="rawData || errorMsg" @click="clickAll">
    <div class="outSideBox">
      <div class="contentBox">
        <div class="titleBox">
          <img
            src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/equityCenterIcon.png"
            alt=""
            class="takeTaxiIcon"
          />
          <div class="titleText">权益中心</div>
        </div>
        <div class="infoBox" :class="{ isExpire: isExpire }">
          <div class="pointBox">
            <span class="label">我的积分</span>
            <span class="value">{{ rawData.points }}</span>
          </div>
          <div class="hint">{{ rawData.desc }}</div>
          <div class="borderLine"></div>
          <img class="image" :src="rawData.image" alt="" />
        </div>
        <!-- 错误信息 -->
        <div
          class="errorMsgBox"
          v-if="errorMsg != ''"
          :class="{ isExpire: isExpire }"
        >
          {{ errorMsg }}
        </div>
        <div
          class="bottomBar"
          :class="{ isExpire: isExpire }"
          @click="clickJumpToH5Btn"
        >
          <div class="moreBox">
            <div class="text">查看更多</div>
            <img
              class="right_arrow_gray"
              src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/right_arrow_gray.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const env = process.env.VUE_APP_ENV;
const config = {
  dxlc: {
    test: "https://lzgj.test.brightcns.cn/benefits/",
    prod: "https://h5-lzgj.brightcns.com/benefits/",
  },
  cxnt: {
    test: "https://h5-ntgj.test.brightcns.cn/benefits/",
    prod: "https://h5-maas.speedits.com/benefits/",
  },
};
export default {
  data: function () {
    return {
      isExpire: false,
      timer: null,
      channel: null,
      type: null,
      rawData: null,
      bizReq: null,
      errorMsg: "",
    };
  },
  props: ["businessContent"],
  mounted: function () {
    console.log(this.businessContent);
    if (this.businessContent.bizCode == "SUCCESS") {
      this.type = this.businessContent.type;
      this.rawData = JSON.parse(this.businessContent.bizData);
      this.channel = this.businessContent.channel;
    } else {
      this.errorMsg = this.businessContent.bizMsg;
    }
    this.checkIsExpire(this.businessContent);
    console.log(this.rawData);
  },
  methods: {
    // 检测卡片是否过期
    checkIsExpire: function (businessContent) {
      let expireTime = new Date(
        businessContent.expireTime.replace(/-/g, "/")
      ).getTime();
      let nowTime = new Date().getTime();
      if (nowTime > expireTime) {
        this.isExpire = true;
      } else {
        console.log("卡片过期时间", expireTime - nowTime);
        this.timer = setTimeout(() => {
          this.isExpire = true;
          clearTimeout(this.timer);
          this.timer = null;
        }, expireTime - nowTime);
      }
    },
    // 点击整个卡片
    clickAll: function () {
      if (this.isExpire) {
        this.$toast("已失效");
        setTimeout(() => {
          this.jumpToH5();
        }, 1000);
      }
    },
    clickJumpToH5Btn: function () {
      if (this.isExpire) {
        return;
      }
      this.jumpToH5();
    },
    // 跳转到h5
    jumpToH5: function () {
      let url = config[this.businessContent.channel][env];
      url =
        url +
        `#/OutsideLoginPage?sessionId=${window.localStorage.getItem(
          "sessionId"
        )}&target=IndexPage`;
      window.location.href = url;
    },
  },
  destroyed: function () {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./equityCenterBox.scss";
</style>
